// frontend/src/components/CollegeDropdown.jsx
import React, { useEffect, useRef } from 'react';
import { Check, Search, School } from 'lucide-react';

const CollegeDropdown = ({ 
  colleges, 
  searchTerm, 
  onSearchChange, 
  selectedCollege, 
  onSelect, 
  isOpen, 
  setIsOpen 
}) => {
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [setIsOpen]);

  // Log colleges data for debugging
  useEffect(() => {
    console.log("Colleges data:", colleges);
  }, [colleges]);

  const filteredColleges = colleges.filter(college => 
    college.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (college.code && college.code.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleCollegeSelect = (college) => {
    console.log("Selected college with degrees:", college); // Debug log
    onSelect(college);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
          <School className="h-5 w-5 text-blue-600" />
        </div>
        <input
          ref={inputRef}
          type="text"
          className="pl-10 w-full rounded-lg border border-gray-300 bg-white py-2 text-gray-900 outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600"
          placeholder="Search for college..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          onClick={() => setIsOpen(true)}
        />
        {selectedCollege && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
            <Check className="h-5 w-5 text-green-600" />
          </div>
        )}
      </div>
      
      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white rounded-lg shadow-lg border border-gray-200 max-h-72 overflow-auto">
          {filteredColleges.length > 0 ? (
            <div className="divide-y divide-gray-100">
              {filteredColleges.map((college) => (
                <div
                  key={college._id}
                  className="cursor-pointer hover:bg-gray-50 transition-colors duration-150"
                  onClick={() => handleCollegeSelect(college)}
                >
                  <div className="p-3 flex items-center space-x-3">
                    {college.logo ? (
                      <img 
                        src={college.logo} 
                        alt={college.name}
                        className="w-10 h-10 rounded-full object-cover border border-gray-200"
                      />
                    ) : (
                      <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
                        <School className="w-6 h-6 text-gray-400" />
                      </div>
                    )}
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-gray-900 truncate">
                        {college.name}
                      </p>
                      <div className="text-xs text-gray-500">
                        {college.code && <span>Code: {college.code}</span>}
                        {college.degrees && (
                          <span className="ml-2">
                            ({college.degrees.length} degrees available)
                          </span>
                        )}
                      </div>
                    </div>
                    {selectedCollege?._id === college._id && (
                      <Check className="h-5 w-5 text-green-600 flex-shrink-0" />
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="p-4 text-center text-gray-500">
              No colleges found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CollegeDropdown;